import React from 'react';
import { Gem } from 'lucide-react';
import { cardLabel } from '../blackjack/PlayingCard';

export const AdminCardSequence = ({ cards, index }) => {
  if (!Array.isArray(cards) || cards.length < 4 || cards.some((card) => !Number.isInteger(card) || card < 0 || card > 51)) {
    return <span role="alert" data-testid={`admin-batch-outcome-${index}`}>Card sequence unavailable. Refresh the preview.</span>;
  }
  const labels = ['Player · first card', 'Dealer · first card', 'Player · second card', 'Dealer · hole card'];
  return <ol className="admin-batch-card-sequence" data-testid={`admin-batch-outcome-${index}`} aria-label="Cards in deal order">
    {cards.map((card, position) => <li key={position} data-testid={`admin-batch-card-${index}-${position}`} data-card={card}>
      <span className="admin-batch-deal-number" data-testid={`admin-batch-card-order-${index}-${position}`}>{position + 1}</span>
      <span className="admin-batch-card-recipient" data-testid={`admin-batch-card-recipient-${index}-${position}`}>{labels[position] || 'Next draw'}</span>
      <strong className="admin-batch-card-face" data-red={card % 4 < 2} data-testid={`admin-batch-card-value-${index}-${position}`}>{cardLabel(card)}</strong>
    </li>)}
  </ol>;
};

export const AdminDiamondPositions = ({ bombs, index }) => {
  if (!Array.isArray(bombs) || !bombs.length || bombs.some((tile) => !Number.isInteger(tile) || tile < 0 || tile > 24)) {
    return <span role="alert" data-testid={`admin-batch-outcome-${index}`}>Diamond positions unavailable. Refresh the preview.</span>;
  }
  const blocked = new Set(bombs);
  const diamonds = Array.from({ length: 25 }, (_, tile) => tile).filter((tile) => !blocked.has(tile));
  return <div className="admin-batch-chips admin-batch-diamonds" data-testid={`admin-batch-outcome-${index}`}>
    {diamonds.map((tile) => <span key={tile} data-testid={`admin-batch-diamond-${index}-${tile}`} aria-label={`Tile ${tile + 1}: diamond`}>
      <Gem size={12} aria-hidden="true" />{tile + 1}
    </span>)}
  </div>;
};